import { OrganizationUsers, TeamUsersDetail } from '@organization/api/requests'
import { dateTimeFormat } from '@organization/utils'
import { ConditionalText, TableActions } from '@shared/components'
import { ColumnsType } from 'antd/es/table'
import { MenuProps } from 'antd/lib'
import dayjs from 'dayjs'

import { useTranslation } from 'react-i18next'

import { AvatarDetails, UserRoleTag } from '../components'

type Data = OrganizationUsers & TeamUsersDetail

export const useUserColumns = (
  getActions: (user: Data) => MenuProps['items']
) => {
  const { t } = useTranslation()

  const columns: ColumnsType<Data> = [
    {
      key: 'first_name',
      sorter: true,
      title: t('table.user'),
      width: 500,
      render: (_, { id, user, status }) => (
        <AvatarDetails id={id} status={status} user={user} />
      )
    },
    {
      key: 'identification_number',
      title: t('identification_number'),
      dataIndex: ['user', 'identification_number'],
      render: (value) => (
        <ConditionalText condition={!!value}>{value}</ConditionalText>
      )
    },
    {
      key: 'last_login',
      sorter: true,
      width: 200,
      title: t('table.last_activity'),
      dataIndex: ['user', 'last_login'],
      render: (_, { user }) =>
        user?.last_login ? dayjs(user?.last_login).format(dateTimeFormat) : '-'
    },
    {
      key: 'job_title',
      title: t('table.job_title'),
      render: (_, { user }) => user?.position ?? '-'
    },
    {
      key: 'role',
      title: t('table.role'),
      dataIndex: 'role',
      render: (_, { role }) => <UserRoleTag role={role} />
    },
    {
      title: t('table.teams'),
      key: 'teams',
      dataIndex: 'teams',
      render: (_, { teams }) =>
        teams?.map((team) => team.name).join(', ') ?? '-'
    },
    {
      key: 'actions',
      align: 'center',
      width: 80,
      render: (_, row) => <TableActions options={getActions(row)} />
    }
  ]

  return columns
}
